module.exports = __webpack_public_path__ + "assets/img/solut1_3.14ff99eb.png";